// Utils > Object
import DataBlock from '../BlockData'

const isObject = (obj: any) => typeof obj === 'object'
const isArray = (obj: any) => Array.isArray(obj)
const isDate = (obj: any) => obj instanceof Date
const isDataBlock = (obj: any) => obj instanceof DataBlock

/**
 * checks if the two are strictly equal
 * @param array1
 * @param array2
 */
export function isEqual(obj1: any, obj2: any): boolean {
	// TODO
	// this is currently a shallow check, does not do a deep comparison
	if (typeof obj1 !== typeof obj1) return false

	const isObj = isObject(obj1)
	const isArr = isArray(obj1)

	if (isObj && isArr) {
		// Array
		if (isArr) {
			if (obj1.length === obj2.length)
				return obj1.every((v: any, ix: number) => v === obj2[ix])
			else return false
		}

		// Date
		if (isDate(obj1)) {
			return obj1.getTime() === obj2.getTime()
		}

		// object
		const keys1 = Object.keys(obj1).sort()
		const keys2 = Object.keys(obj2).sort()
		const values1 = Object.values(obj1).sort()
		const values2 = Object.values(obj2).sort()
		return isEqual(keys1, keys2) && isEqual(values1, values2)
	} else {
		return obj1 === obj2
	}
}

/**
 * returns a recursive duplicate of the object passed in
 * @param obj
 */
export function deepCopy(
	obj: { [key: string]: any } | Array<any>
): { [key: string]: any } | Array<any> | undefined {
	if (isObject(obj)) {
		// Array
		if (isArray(obj)) {
			const a = obj as Array<any>
			const copy = []

			for (let i = 0, n = obj.length; i < n; i++) {
				let copiedElement
				const current = a[i]

				if (typeof current === 'object') {
					copiedElement = deepCopy(current)
				} else {
					copiedElement = current
				}

				copy.push(copiedElement)
			}

			return copy
		}

		// Date
		if (isDate(obj)) {
			const d = obj as Date
			return new Date(d.getTime())
		}

		// DataBlock
		if (isDataBlock(obj)) {
			return Object.assign(Object.create(Object.getPrototypeOf(obj)), obj)
		}

		const o = obj as { [key: string]: any }
		const copy: { [key: string]: any } = {}
		const keys = Object.keys(obj)

		for (let i = 0, n = keys.length; i < n; i++) {
			let copiedElement
			const key = keys[i]
			const current = o[key]

			if (typeof current === 'object') {
				copiedElement = deepCopy(current)
			} else {
				copiedElement = current
			}

			copy[key] = copiedElement
		}

		return copy
	} else {
		return obj
	}
}
